import React from "react";
import classNames from "classnames";

export interface IProps {
  type: "windows" | "mac" | "video";
  classes?: string;
}
const GuideIcon: React.FC<IProps> = ({ classes, type }) => {
  return type === "windows" ? (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="24" fill="#DFF6EA" />
      <rect x="16" y="14" width="32" height="36" rx="6" fill="#3BC77D" />
      <rect x="24" y="24" width="7.11111" height="7.11111" fill="white" />
      <rect x="24" y="32.8887" width="7.11111" height="7.11111" fill="white" />
      <rect x="32.8887" y="24" width="7.11111" height="7.11111" fill="white" />
      <rect
        x="32.8887"
        y="32.8887"
        width="7.11111"
        height="7.11111"
        fill="white"
      />
    </svg>
  ) : type === "mac" ? (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="24" fill="#FFF0DC" />
      <rect x="16" y="14" width="32" height="36" rx="6" fill="#F7BB5B" />
      <path
        d="M36.5519 32.459C36.5441 31.1403 37.1416 30.1465 38.3482 29.4136C37.6734 28.4468 36.6524 27.9151 35.3066 27.8126C34.0324 27.7121 32.6383 28.5551 32.1278 28.5551C31.5883 28.5551 30.3547 27.8474 29.384 27.8474C27.3808 27.8784 25.252 29.4446 25.252 32.6311C25.252 33.5728 25.424 34.5454 25.7682 35.547C26.2284 36.8657 27.8874 40.0967 29.618 40.0445C30.5229 40.0233 31.1629 39.4026 32.3405 39.4026C33.4833 39.4026 34.0749 40.0445 35.0843 40.0445C36.8303 40.0194 38.3308 37.0823 38.7678 35.7597C36.4262 34.6556 36.5519 32.5267 36.5519 32.459ZM34.5197 26.5616C35.5 25.3976 35.4111 24.3379 35.3821 23.957C34.5158 24.0073 33.5142 24.5468 32.9438 25.21C32.3154 25.9216 31.9461 26.8013 32.0253 27.7933C32.9612 27.8648 33.8158 27.3834 34.5197 26.5616Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="64" height="64" rx="24" fill="#DEEAFF" />
      <rect
        x="16.0874"
        y="13.9219"
        width="32"
        height="36"
        rx="6"
        transform="rotate(0.277328 16.0874 13.9219)"
        fill="#5E92F5"
      />
      <path
        d="M38.1417 33.715C39.4364 32.9382 39.4364 31.0618 38.1417 30.285L29.029 24.8174C27.6959 24.0176 26 24.9778 26 26.5324L26 37.4676C26 39.0222 27.6959 39.9824 29.029 39.1826L38.1417 33.715Z"
        fill="white"
      />
    </svg>
  );
};

export default GuideIcon;
